import { RouteObject } from 'react-router-dom';
import { Page404 } from 'src/error-page';
import { lazyConReintento } from 'src/config/lazy-con-reintento';
import { diferida } from 'src/config/pagina-diferida';

const AvailabilityView = lazyConReintento(() => import('./index'));
const CreateAvailabilitySlotView = lazyConReintento(() => import('./create'));
const OpenAvailabilitySlotDetailsView = lazyConReintento(() => import('./open-slots/slot-view'));

const availabilityRoutes: RouteObject[] = [
  {
    path: 'availability/new',
    element: diferida(<CreateAvailabilitySlotView />)
  },
  {
    path: 'availability',
    element: diferida(<AvailabilityView />)
  },
  {
    path: 'availability/slot/:id',
    element: diferida(<OpenAvailabilitySlotDetailsView />)
  },
  {
    path: '*',
    element: <Page404 />
  }
];

export default availabilityRoutes;
